module.exports = __webpack_public_path__ + "img/short_loop-poster.1929ee01.jpg";